import { useEffect, useRef, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const goFullscreen = () => {
  const el = document.documentElement;
  (el.requestFullscreen || el.webkitRequestFullscreen)?.call(el)?.catch?.(() => {});
};

// Öğrenci başka sekmeye/uygulamaya geçerse öğretmene ve tahtaya bildirir; dönünce uyarı gösterir.
export const FocusGuard = ({ send, connected }) => {
  const [warn, setWarn] = useState(false);
  const away = useRef(false);
  useEffect(() => {
    const set = (v) => {
      if (away.current === v) return;
      away.current = v;
      send({ type: "focus", away: v });
      if (!v) setWarn(true);
    };
    const onVis = () => set(document.visibilityState === "hidden");
    const onBlur = () => set(true);
    const onFocus = () => set(false);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("blur", onBlur);
    window.addEventListener("focus", onFocus);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", onFocus);
    };
  }, [send]);
  useEffect(() => {
    if (connected) send({ type: "focus", away: away.current });
  }, [connected, send]);
  if (!warn) return null;
  return (
    <div className="fixed inset-0 z-50 bg-[#0B0F16]/95 grid place-items-center p-6" data-testid="focus-warning">
      <div className="panel p-6 max-w-sm text-center space-y-4 border-2 border-[#FACC15] anim-shake">
        <AlertTriangle className="h-12 w-12 mx-auto text-[#FACC15]" />
        <p className="font-display text-2xl font-bold">Oyundan çıktın!</p>
        <p className="text-slate-300">Başka bir uygulamaya geçtiğin öğretmenine ve tahtaya bildirildi. Lütfen oyunda kal.</p>
        <Button className="w-full h-14 text-lg" onClick={() => { goFullscreen(); setWarn(false); }} data-testid="focus-return-button">Oyuna dön</Button>
      </div>
    </div>
  );
};
